import { render } from "./EmptyData.vue?vue&type=template&id=474da866&scoped=true"
const script = {}

import "./EmptyData.vue?vue&type=style&index=0&id=474da866&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-474da866"]])

export default __exports__